{
  "PROFILE_SETTINGS": {
    "LINK": "Profilbeállítások",
    "TITLE": "Profilbeállítások",
    "BTN_TEXT": "Profil frissítése",
    "DELETE_AVATAR": "Avatár Törlése",
    "AVATAR_DELETE_SUCCESS": "Az avatár sikeresen törlésre került",
    "AVATAR_DELETE_FAILED": "Hiba lépett fel az avatár törlése során, kérjük próbáld újra",
    "UPDATE_SUCCESS": "A fiókod sikeresen frissítetted",
    "PASSWORD_UPDATE_SUCCESS": "A jelszavad sikeresen megváltoztattad",
    "AFTER_EMAIL_CHANGED": "A profilod sikeresen frissítésre került, kérjük lépj be újra, mivel megváltoztak a belépési adataid",
    "FORM": {
      "PICTURE": "Profilkép",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "E-mail aláírás képe",
        "HINT": "Az e-mail aláírásokban használatos. A {'{{'}email_signature_picture{'}}'} helyére a kép URL-címe kerül (nem képcímke) — használja képforrásként (egy img címke src attribútumaként) az aláírásában vagy a postaláda aláírásában. Ha nincs beállítva, semmi sem kerül beszúrásra.",
        "DELETE_SUCCESS": "Az e-mail aláírás képe sikeresen törölve lett",
        "DELETE_FAILED": "Hiba történt az e-mail aláírás képének törlésekor, kérjük, próbálja újra"
      },
      "AVATAR": "Profilkép",
      "ERROR": "Kérjük javítsd ki az űrlaphibákat",
      "REMOVE_IMAGE": "Eltávolítás",
      "UPLOAD_IMAGE": "Kép feltöltése",
      "UPDATE_IMAGE": "Kép frissítése",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Az e-mailcímed az identitásod és a belépésre használhatod."
      },
      "SEND_MESSAGE": {
        "TITLE": "Üzenet küldése gyorsbillentyűvel",
        "NOTE": "Kiválaszthatod a gyorsbillentyű kombinációdat a preferenciáid alapján.",
        "UPDATE_SUCCESS": "A beállításaid sikeresen frissültek.",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Küldj üzenetet az Enter gomb megnyomásával a \"Küldés gomb\" használata helyett"
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Küldj üzenetet az Cmd/Ctrl + enter billentyűkombinációval a \"Küldés gomb\" használata helyett"
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Felület",
        "NOTE": "Testreszabhatja az irányítópult megjelenését és működését.",
        "FONT_SIZE": {
          "TITLE": "Betűméret",
          "NOTE": "Állítsa be a szöveg méretét az irányítópulton az Ön preferenciái szerint.",
          "UPDATE_SUCCESS": "A betűméret beállításai sikeresen frissítésre kerültek",
          "UPDATE_ERROR": "Hiba történt a betűméret beállításainak frissítése közben, kérjük, próbálja újra",
          "OPTIONS": {
            "SMALLER": "Kisebb",
            "SMALL": "Kis",
            "DEFAULT": "Alapértelmezett",
            "LARGE": "Nagy",
            "LARGER": "Nagyobb",
            "EXTRA_LARGE": "Extra nagy"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Irányítópult nyelve",
          "NOTE": "Felülírja a fiók nyelvét a saját irányítópultján. Hagyja üresen a fiók alapértelmezett nyelvének használatához.",
          "USE_ACCOUNT_DEFAULT": "Fiók alapértelmezett használata",
          "API_SUCCESS": "Az irányítópult nyelve sikeresen frissítve",
          "API_ERROR": "Hiba történt az irányítópult nyelvének frissítésekor, kérjük, próbálja újra"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Üzenet nyelve",
          "NOTE": "Válassza ki, hogy az eredeti üzeneteket vagy a fordításukat jelenítse meg",
          "ORIGINAL": "Eredeti",
          "TRANSLATED": "Fordított"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Beillesztési viselkedés",
          "NOTE": "Válassza ki, hogyan legyen feldolgozva a beillesztett tartalom üzenetíráskor",
          "UPDATE_SUCCESS": "A beillesztési beállításai sikeresen frissítve",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Minden formázás megőrzése",
              "DESCRIPTION": "Minden formázás megőrzése, beleértve a táblázatokat, stílusokat és egyéb HTML elemeket a tartalom beillesztésekor."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Csak szöveg hivatkozásokkal",
              "DESCRIPTION": "Egyszerű szöveggé alakítja, de megőrzi a kattintható hivatkozásokat a tartalom beillesztésekor."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Csak egyszerű szöveg",
              "DESCRIPTION": "Eltávolít minden formázást, és egyszerű szöveggé alakít a tartalom beillesztésekor."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Válaszmező magassága",
          "NOTE": "Állítsa be a válaszmező minimális magasságát a képernyő magasságának százalékában. Csak az e-mailes beszélgetésekre vonatkozik.",
          "UPDATE_SUCCESS": "A válaszmező magasságának beállítása sikeresen frissítve",
          "PERCENT_LABEL": "Magasság (a képernyő magasságának %-a)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Alapértelmezett",
              "DESCRIPTION": "A válaszmező kicsiként indul, és gépelés közben egyre nagyobb lesz."
            },
            "CUSTOM": {
              "HEADING": "Egyéni",
              "DESCRIPTION": "A válaszmező mindig legalább a kiválasztott százalékos arányban foglalja el a képernyő magasságát."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Automatikus ugrás a következő beszélgetésre",
        "NOTE": "Az aktuális beszélgetés lezárása után automatikusan váltson a következő nyitott beszélgetésre",
        "UPDATE_SUCCESS": "Az automatikus ugrás beállítás sikeresen frissítve"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "E-mail előnézet formátuma a beszélgetéslistában",
        "NOTE": "Válassza ki, hogy mi jelenjen meg a beszélgetéslistában az e-mail postafiókokból érkező beszélgetéseknél",
        "SUBJECT": "Tárgy",
        "SUBJECT_WITH_NOTE": "Tárgy és az utolsó üzenet, ha az egy belső megjegyzés",
        "UPDATE_SUCCESS": "Az e-mail előnézet beállítás sikeresen frissítve"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Billentyűparancsok letiltása",
        "NOTE": "Az összes billentyűparancs kikapcsolása az alkalmazásban",
        "UPDATE_SUCCESS": "A billentyűparancs beállítás sikeresen frissítve"
      },
      "FOLDER_ORDER": {
        "TITLE": "Mappa sorrendje",
        "NOTE": "Testreszabhatja a mappák (egyéni nézetek) megjelenési sorrendjét az oldalsávban. Húzza és ejtse az átrendezéshez.",
        "NO_FOLDERS": "Nem találhatók egyéni mappák. Hozzon létre mappákat a beszélgetések rendszerezéséhez."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Oldalsáv konfiguráció",
        "NOTE": "Testreszabhatja, mely szekciók jelenjenek meg a beszélgetések oldalsávjában.",
        "SAVE_BUTTON": "Konfiguráció mentése",
        "UPDATE_SUCCESS": "Oldalsáv konfiguráció sikeresen frissítve",
        "UPDATE_ERROR": "Hiba történt az oldalsáv konfiguráció frissítésekor, kérjük, próbálja újra",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Összes beszélgetés",
          "ALL_CONVERSATIONS_DESC": "Az Összes beszélgetés menüpont megjelenítése az oldalsávban",
          "INBOX": "Postafiók",
          "INBOX_DESC": "A fő postafiók megjelenítése olvasatlan értesítésekkel",
          "CONVERSATION_GROUPS": "Említések és Felügyelet nélkül",
          "CONVERSATION_GROUPS_DESC": "Az Említések és Felügyelet nélküli beszélgetés csoportok megjelenítése",
          "FOLDERS": "Mappák",
          "FOLDERS_DESC": "Egyéni nézetek (mappák) megjelenítése rendszerezett beszélgetésekhez",
          "TEAMS": "Csapatok",
          "TEAMS_DESC": "Csapat hozzárendelés szerint szűrt beszélgetések megjelenítése",
          "CHANNELS": "Postafiókok",
          "CHANNELS_DESC": "Postafiók szerint szűrt beszélgetések megjelenítése",
          "LABELS": "Címkék",
          "LABELS_DESC": "Címke szerint szűrt beszélgetések megjelenítése"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Telefon beállítások",
        "NOTE": "Adja meg a PBX rendszer bejelentkezési adatait.",
        "USERNAME": "Felhasználónév",
        "PASSWORD": "Jelszó",
        "SUBMIT": "Mentés",
        "USERNAME_INVALID": "A felhasználónév csak betűket, számokat és a . _ - + karaktereket tartalmazhatja — szóköz és e-mail cím nem megengedett.",
        "API": {
          "USERNAME_INVALID": "A felhasználónév nem érvényes SIP felhasználónév. Csak betűket, számokat és a . _ - + karaktereket használjon — szóköz és e-mail cím nem megengedett.",
          "USERNAME_TAKEN": "Ezt a felhasználónevet már használja egy másik ügynök ebben a fiókban."
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Személyes üzenet aláírás",
        "DESCRIPTION": "Hozzon létre egyedi üzenet aláírást, amely minden elküldött e-mail végén megjelenik. Beágyazott képet is használhat.",
        "NOTE": "Hozzon létre egyedi üzenetaláírást, amely bármelyik postafiókból küldött üzenet végén megjelenik. Beilleszthet egy soron belüli képet is, amelyet az élő chat, az e-mail és az API bejövő üzenetek támogatnak.",
        "BTN_TEXT": "Üzenet aláírás mentése",
        "API_ERROR": "Nem sikerült menteni az aláírást! Próbáld újra",
        "API_SUCCESS": "Aláírás sikeresen mentve",
        "IMAGE_UPLOAD_ERROR": "A képet nem lehet betölteni! Próbálja újra",
        "IMAGE_UPLOAD_SUCCESS": "A kép sikeresen hozzáadva. Az aláírás mentéséhez kattintson a mentésre",
        "IMAGE_UPLOAD_SIZE_ERROR": "A kép mérete kevesebb, mint {size} MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Üzenet aláírás",
        "ERROR": "Az üzenet aláírása nem maradhat üres",
        "PLACEHOLDER": "Ide írd a személyes üzeneteid aláírását."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Jelszó",
        "NOTE": "A jelszó frissítása minden beléptetett eszközt kiléptet.",
        "BTN_TEXT": "Jelszó megváltoztatása"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Hozzáférési kulcs",
        "NOTE": "Ez a kulcs akkor használható, ha API-alapú integrációt építesz",
        "COPY": "Másolás",
        "REGENERATE": "Újragenerálás",
        "REGENERATE_SUCCESS": "Hozzáférési token sikeresen újragenerálva. Kérjük, frissítse a régi tokent használó integrációkat.",
        "REGENERATE_CONFIRM_TITLE": "Hozzáférési token újragenerálása?",
        "REGENERATE_CONFIRM_MESSAGE": "Ez érvényteleníti az aktuális tokent. A régi tokent használó integrációk le fognak állni."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome bővítmény",
        "NOTE": "Telepítse chrome bővítményünket a bejövő telefonhívásokról szóló részletes értesítésekhez.",
        "INSTALL_BUTTON": "Bővítmény telepítése",
        "ALREADY_INSTALLED": "Bővítmény telepítve"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Hangjelzések",
        "NOTE": "Engedélyezze a hangjelzéseket az irányítópulton új üzenetek és beszélgetések esetén.",
        "PLAY": "Hang lejátszása",
        "ALERT_TYPES": {
          "NONE": "Nincs",
          "MINE": "Hozzám rendelt",
          "ALL": "Összes",
          "ASSIGNED": "Hozzám rendelt beszélgetések",
          "UNASSIGNED": "Nem hozzárendelt beszélgetések",
          "NOTME": "Másokhoz rendelt nyitott beszélgetések"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Nem választott ki egyetlen lehetőséget sem, így nem fog hangjelzéseket kapni.",
          "ASSIGNED": "Értesítést kap az Önnek kiosztott beszélgetésekről.",
          "UNASSIGNED": "Értesítést kap minden nem hozzárendelt beszélgetésről.",
          "NOTME": "Értesítést kap a másokhoz rendelt beszélgetésekről.",
          "ASSIGNED+UNASSIGNED": "Értesítést kap az Önnek kiosztott és a még nem kezelt beszélgetésekről.",
          "ASSIGNED+NOTME": "Értesítést kap az Önnek és másoknak kiosztott beszélgetésekről, de nem a nem hozzárendeltekről.",
          "NOTME+UNASSIGNED": "Értesítést kap a még nem kezelt és a másokhoz rendelt beszélgetésekről.",
          "ASSIGNED+NOTME+UNASSIGNED": "Értesítést kap az összes beszélgetésről."
        },
        "ALERT_TYPE": {
          "TITLE": "Beszélgetésekhez tartozó értesítési események",
          "NONE": "Nincs",
          "ASSIGNED": "Hozzárendelt Beszélgetések",
          "ALL_CONVERSATIONS": "Beszélgetések"
        },
        "DEFAULT_TONE": {
          "TITLE": "Hang figyelmeztetés:"
        },
        "CONDITIONS": {
          "TITLE": "Figyelmeztető feltételek:",
          "CONDITION_ONE": "Csak akkor küldjön hangjelzést, ha a böngészőablak nem aktív",
          "CONDITION_TWO": "Figyelmeztetések küldése 30 másodpercenként, amíg az összes hozzárendelt beszélgetést elolvasta"
        },
        "SOUND_PERMISSION_ERROR": "Az automatikus lejátszás le van tiltva a böngészőjében. Az értesítési hangok automatikus lejátszásához engedélyezze a hangot a böngésző beállításaiban, vagy lépjen interakcióba az oldallal.",
        "READ_MORE": "Tudj meg többet"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-mail értesítések",
        "NOTE": "Frissítsd az e-mail értesítési beállításaidat itt",
        "CONVERSATION_ASSIGNMENT": "Küldj e-mail értesítéseket, amikor a beszélgetést hozzám rendelik",
        "CONVERSATION_CREATION": "Küldj e-mail értesítéseket, amikor egy új beszélgetés létrejön",
        "CONVERSATION_MENTION": "Küldj e-mail értesítéseket, amikor egy beszélgetésben megemlítenek",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Küldj e-mail értesítéseket, amikor egy hozzám rendelt beszélgetésben új üzenet érkezik",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Kapj e-mailt amikor egy üzenet létrejön egy hozzád rendelt beszélgetésben",
        "SLA_MISSED_FIRST_RESPONSE": "E-mail-értesítés küldése, ha egy beszélgetés nem teljesíti az első válaszra vonatkozó SLA-t",
        "SLA_MISSED_NEXT_RESPONSE": "E-mail-értesítés küldése, ha egy beszélgetés nem teljesíti a következő válaszra vonatkozó SLA-t",
        "SLA_MISSED_RESOLUTION": "E-mail-értesítés küldése, ha egy beszélgetés nem teljesíti a megoldásra vonatkozó SLA-t"
      },
      "NOTIFICATIONS": {
        "TITLE": "Értesítési beállítások",
        "TYPE_TITLE": "Értesítés típusa",
        "EMAIL": "E-mail",
        "PUSH": "Push értesítés",
        "TYPES": {
          "CONVERSATION_CREATED": "Új beszélgetés jött létre",
          "CONVERSATION_ASSIGNED": "Egy beszélgetést Önhöz rendeltek",
          "CONVERSATION_MENTION": "Megemlítették Önt egy beszélgetésben",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Új üzenet érkezett egy Önhöz rendelt beszélgetésben",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Új üzenet érkezett egy olyan beszélgetésben, amelyben részt vesz",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Új üzenet érkezett egy nem hozzárendelt beszélgetésben",
          "SLA_MISSED_FIRST_RESPONSE": "A beszélgetés nem teljesítette az első válaszra vonatkozó SLA-t",
          "SLA_MISSED_NEXT_RESPONSE": "A beszélgetés nem teljesítette a következő válaszra vonatkozó SLA-t",
          "SLA_MISSED_RESOLUTION": "A beszélgetés nem teljesítette a megoldásra vonatkozó SLA-t"
        },
        "BROWSER_PERMISSION": "Engedélyezze a push értesítéseket a böngészőjében, hogy fogadhassa azokat",
        "ALLOW_NOTIFICATION_DURING_CALL": "Push értesítések engedélyezése hívás közben",
        "TEST_PUSH": "Teszt",
        "TESTING": "Tesztelés...",
        "TEST_PUSH_DESCRIPTION": "Teszt értesítések küldése a beállítás ellenőrzéséhez",
        "TEST_NOTIFICATION_ERROR": "Nem sikerült elküldeni a teszt értesítést. Kérjük, próbálja újra.",
        "TEST_LOCAL_TITLE": "Teszt értesítés (helyi)",
        "TEST_LOCAL_BODY": "Ez egy helyi böngésző értesítés. Ha látja ezt, a böngésző értesítések működnek!"
      },
      "API": {
        "UPDATE_SUCCESS": "Az értesítési beállításaid sikeresen frissítve",
        "UPDATE_ERROR": "Egy hiba lépett fel a beállítások frissítése során, kérjük próbáld újra"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push üzenetek",
        "NOTE": "Frissítsd az push üzenet beállításaidat itt",
        "CONVERSATION_ASSIGNMENT": "Küldj push üzeneteket, amikor a beszélgetést hozzám rendelik",
        "CONVERSATION_CREATION": "Küldj push üzeneteket, amikor egy új beszélgetés létrejön",
        "CONVERSATION_MENTION": "Küldj push üzeneteket, amikor egy beszélgetésben megemlítenek",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Küldj push üzeneteket, amikor egy hozzám rendelt beszélgetésben új üzenet érkezik",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Kapj push értesítést amikor egy üzenet létrejön egy hozzád rendelt beszélgetésben",
        "HAS_ENABLED_PUSH": "Engedélyezted a push üzeneteket ezen a böngészőn.",
        "REQUEST_PUSH": "Push üznetek engedélyezése",
        "SLA_MISSED_FIRST_RESPONSE": "Push-értesítés küldése, ha egy beszélgetés nem teljesíti az első válaszra vonatkozó SLA-t",
        "SLA_MISSED_NEXT_RESPONSE": "Push-értesítés küldése, ha egy beszélgetés nem teljesíti a következő válaszra vonatkozó SLA-t",
        "SLA_MISSED_RESOLUTION": "Push-értesítés küldése, ha egy beszélgetés nem teljesíti a megoldásra vonatkozó SLA-t"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profilkép"
      },
      "NAME": {
        "LABEL": "A teljes neved",
        "ERROR": "Kérjük helyes nevet adj meg",
        "PLACEHOLDER": "Kérjük a teljes nevedet add meg"
      },
      "DISPLAY_NAME": {
        "LABEL": "Rövidnév",
        "ERROR": "Kérjük helyes rövidnevet adj meg",
        "PLACEHOLDER": "Kérjük add meg a rövidnevet amit a beszélgetésekben szeretnél megjeleníteni"
      },
      "POSITION": {
        "LABEL": "Beosztás",
        "ERROR": "Adjon meg érvényes beosztást",
        "PLACEHOLDER": "Adja meg a beosztását"
      },
      "CUSTOM_LINE": {
        "LABEL": "Egyéni sor",
        "ERROR": "Adjon meg érvényes egyéni sort",
        "PLACEHOLDER": "Adja meg az egyéni sorát"
      },
      "AVAILABILITY": {
        "LABEL": "Elérhetőség",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Foglalt",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Elérhetőség beállítása sikeres",
        "SET_AVAILABILITY_ERROR": "Nem sikerült beállítani az elérhetőséget, kérlek, próbáld újra"
      },
      "EMAIL": {
        "LABEL": "Az e-mailcímed",
        "ERROR": "Kérjük helyes e-mailcímet adj meg",
        "PLACEHOLDER": "Kérjük add meg az e-mailcímet amit a beszélgetésekben szeretnél megjeleníteni"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Jelenlegi jelszó",
        "ERROR": "Kérjük add meg a jelenlegi jelszavad",
        "PLACEHOLDER": "Kérjük add meg a jelenlegi jelszavad"
      },
      "PASSWORD": {
        "LABEL": "Új jelszó",
        "ERROR": "Kérjük 6 karakternél hosszabb jelszót adj meg",
        "PLACEHOLDER": "Kérjük adj meg egy új jelszót"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Jelszó megerősítése",
        "ERROR": "A két jelszónak egyeznie kell",
        "PLACEHOLDER": "Kérjük add meg egy ismét új jelszavad"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Állapot módosítása",
    "CHANGE_ACCOUNTS": "Fiók váltása",
    "SWITCH_ACCOUNT": "Fiók váltása",
    "CONTACT_SUPPORT": "Kapcsolatfelvétel az ügyfélszolgálattal",
    "REPORT_BUG": "Hiba jelentése",
    "SELECTOR_SUBTITLE": "Válasszon fiókot az alábbi listából",
    "PROFILE_SETTINGS": "Profilbeállítások",
    "KEYBOARD_SHORTCUTS": "Billentyűparancsok",
    "APPEARANCE": "Megjelenés módosítása",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin konzol",
    "DOCS": "Dokumentáció megtekintése",
    "LOGOUT": "Kijelentkezés"
  },
  "BUG_REPORT": {
    "TITLE": "Hiba jelentése",
    "DESCRIPTION_LABEL": "Probléma leírása",
    "DESCRIPTION_PLACEHOLDER": "Írja le a tapasztalt problémát...",
    "SUBMIT": "Jelentés küldése",
    "SUBMITTING": "Küldés...",
    "CANCEL": "Mégse",
    "SUCCESS": "A hiba jelentés sikeresen elküldve. Köszönjük!",
    "ERROR": "Nem sikerült elküldeni a hiba jelentést. Kérjük, próbálja újra.",
    "VALIDATION_ERROR": "Kérjük, írja le a problémát a beküldés előtt"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "nap van hátra a próbaidőszakból.",
    "TRAIL_BUTTON": "Előfizetés",
    "DELETED_USER": "Törölt felhasználó",
    "EMAIL_VERIFICATION_PENDING": "Úgy tűnik, még nem erősítette meg az e-mail-címét. Kérjük, ellenőrizze a beérkező levelek mappáját a megerősítő e-mailért.",
    "RESEND_VERIFICATION_MAIL": "Megerősítő e-mail újraküldése",
    "EMAIL_VERIFICATION_SENT": "A megerősítő e-mail elküldésre került. Kérjük, ellenőrizze a beérkező leveleit.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Felfüggesztett fiók",
      "MESSAGE": "A fiókja fel van függesztve. További információért kérjük, vegye fel a kapcsolatot az ügyfélszolgálattal."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Másolás",
      "CODEPEN": "Megnyitás CodePen-ben",
      "COPY_SUCCESSFUL": "Vágólapra másolva"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Mutass többet",
      "SHOW_LESS": "Mutass kevesebbet"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Letöltés",
      "UPLOADING": "Feltöltés...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Ez a story már nem érhető el.",
      "RECORDING_UNAVAILABLE": "Ez a felvétel már nem érhető el.",
      "DELETE_RECORDING": {
        "BUTTON": "Hívásrögzítés törlése",
        "TITLE": "Törli a hívásrögzítést?",
        "DESCRIPTION": "A hívás összes felvétele véglegesen törlődik a telefonrendszerből, és nem állítható vissza. A hívás átirata és összefoglalója megmarad.",
        "CONFIRM": "Törlés",
        "SUCCESS": "A hívásrögzítés törölve",
        "ERROR": "Nem sikerült törölni a hívásrögzítést. Kérjük, próbálja újra."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Mutasd térképen"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Elküldés"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Ez a kép már nem érhető el.",
      "LOADING_FAILED": "A betöltés sikertelen"
    }
  },
  "CONFIRM_EMAIL": "Ellenőrzés...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Inboxhoz adás"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Nincs elem",
    "CURRENTLY_VIEWING_ACCOUNT": "Jelenleg megtekintett fiók:",
    "SWITCH": "Váltás",
    "INBOX_VIEW": "Bejövő nézet",
    "CONVERSATIONS": "Beszélgetések",
    "INBOX": "Saját bejövő",
    "ALL_CONVERSATIONS": "Beszélgetések",
    "MENTIONED_CONVERSATIONS": "Megemlítések",
    "PARTICIPATING_CONVERSATIONS": "Részvétel",
    "UNATTENDED_CONVERSATIONS": "Kezeletlen",
    "REPORTS": "Jelentések",
    "SETTINGS": "Beállítások",
    "CONTACTS": "Kapcsolatok",
    "DATA_ASSISTANT": "Adatasszisztens",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Asszisztensek",
    "CAPTAIN_DOCUMENTS": "Dokumentumok",
    "CAPTAIN_RESPONSES": "GYIK",
    "HOME": "Kezdőlap",
    "AGENTS": "Ügynökök",
    "AGENT_BOTS": "Botok",
    "AUDIT_LOGS": "Audit naplók",
    "WHATSAPP_TEMPLATES": "WhatsApp sablonok",
    "BLOCKED_DOMAINS": "Spam",
    "INBOXES": "Bejövők",
    "NOTIFICATIONS": "Értesítések",
    "CANNED_RESPONSES": "Mentett válaszok",
    "INTEGRATIONS": "Integrációk",
    "PROFILE_SETTINGS": "Profilbeállítások",
    "ACCOUNT_SETTINGS": "Fiókbeállítások",
    "APPLICATIONS": "Alkalmazások",
    "LABELS": "Címkék",
    "CUSTOM_ATTRIBUTES": "Egyedi attribútumok",
    "AUTOMATION": "Automatizálás",
    "MACROS": "Makrók",
    "TEAMS": "Csapatok",
    "BILLING": "Számlázás",
    "CUSTOM_VIEWS_FOLDER": "Mappák",
    "CUSTOM_VIEWS_SEGMENTS": "Szegmensek",
    "ALL_CONTACTS": "Összes kapcsolat",
    "TAGGED_WITH": "Megjelölve",
    "NEW_LABEL": "Új címke",
    "NEW_TEAM": "Új csapat",
    "NEW_INBOX": "Új bejövő",
    "REPORTS_CONVERSATION": "Beszélgetések",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Élő chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Kampányok",
    "ONGOING": "Folyamatban",
    "ONE_OFF": "Egyszeri",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Ügynökök",
    "REPORTS_LABEL": "Címkék",
    "REPORTS_INBOX": "Bejövő",
    "REPORTS_TEAM": "Csapat",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Áttekintés",
    "WALLBOARD_QUEUES": "Sorok",
    "WALLBOARD_AGENTS": "Ügynök áttekintés",
    "DATA_ASSISTANT_CHAT": "Csevegés",
    "DATA_ASSISTANT_REPORTS": "Jelentések",
    "NO_WAITING_CALLERS": "nincsenek várakozó hívók",
    "WAITING_CALLERS": "{count} hívó várakozik",
    "SET_AVAILABILITY_TITLE": "Ugrás a beszélgetési irányítópultra",
    "SET_YOUR_AVAILABILITY": "Elérhetőség beállítása",
    "AVAILABILITY_IMPERSONATING": "Zárolva, amíg ezzel a felhasználóval van bejelentkezve",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Egyedi szerepkörök",
    "NEW_CONVERSATION": "Új beszélgetés",
    "DRAFT": "Piszkozat",
    "BETA": "Béta",
    "REPORTS_OVERVIEW": "Áttekintés",
    "REAUTHORIZE": "A bejövő kapcsolata lejárt, kérjük, csatlakoztassa újra\n az üzenetek fogadásának és küldésének folytatásához",
    "HELP_CENTER": {
      "TITLE": "Súgóközpont",
      "ARTICLES": "Cikkek",
      "CATEGORIES": "Kategóriák",
      "LOCALES": "Nyelvek",
      "SETTINGS": "Beállítások",
      "DICTIONARY": "Szótár"
    },
    "CHANNELS": "Csatornák",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Automatikus offline állapot",
      "INFO_TEXT": "Engedje, hogy a rendszer automatikusan offline állapotba állítsa, amikor nem használja az alkalmazást vagy az irányítópultot.",
      "INFO_SHORT": "Automatikusan offline állapotba kerül, ha nem használja az alkalmazást."
    },
    "DOCS": "Dokumentáció megtekintése"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blokkolt domainek és kapcsolattartók",
    "DESCRIPTION": "A fiókhoz blokkolt e-mail domainek listája.",
    "NO_BLOCKED_DOMAINS": "Nem találhatók blokkolt domainek.",
    "BLOCKED_CONTACTS_BTN": "Blokkolt kapcsolattartók"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Számlázás",
    "DESCRIPTION": "Itt kezelheti az előfizetését, válthat magasabb csomagra, és többet kaphat a csapata számára.",
    "CURRENT_PLAN": {
      "TITLE": "Aktuális előfizetés",
      "PLAN_NOTE": "Jelenleg előfizetett a **{plan}** csomagra **{quantity}** licensszel",
      "SEAT_COUNT": "Férőhelyek száma",
      "RENEWS_ON": "Megújulás dátuma"
    },
    "VIEW_PRICING": "Árak megtekintése",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Előfizetés kezelése",
      "DESCRIPTION": "Korábbi számlák nézete, fizetési részletek szerkesztése, vagy az előfizetés törlése",
      "BUTTON_TXT": "Ugrás a számlázási felületre"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Kezelje a Captain AI használatát és kreditjeit.",
      "BUTTON_TXT": "További kreditek vásárlása",
      "DOCUMENTS": "Dokumentumok",
      "RESPONSES": "Válaszok",
      "UPGRADE": "A Captain nem érhető el az ingyenes csomagban, frissítsen most, hogy hozzáférjen az asszisztensekhez, a copilothoz és további funkciókhoz."
    },
    "CHAT_WITH_US": {
      "TITLE": "Kell segítség?",
      "DESCRIPTION": "Számlázási problémád akadt? Azért vagyunk itt, hogy segítsünk.",
      "BUTTON_TXT": "Chatelj velünk"
    },
    "NO_BILLING_USER": "Számlázási fiókod konfigurálás alatt áll. Kérjük, frissítsd az oldalt, és próbáld újra."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Uppsz! Nem találtunk egyetlen fiókot sem. A folytatáshoz kérjük, hozzon létre egy új fiókot.",
    "NEW_ACCOUNT": "Új fiók",
    "SELECTOR_SUBTITLE": "Új fiók létrehozása",
    "API": {
      "SUCCESS_MESSAGE": "Ügynök sikeresen létrehozva",
      "EXIST_MESSAGE": "A fiók már létezik",
      "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Cégnév",
        "PLACEHOLDER": "Kovács Kft."
      },
      "SUBMIT": "Elküldés",
      "CANCEL": "Mégse"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Összes parancsikon nézete",
    "TITLE": {
      "OPEN_CONVERSATION": "Beszélgetés megnyitása",
      "RESOLVE_AND_NEXT": "Feloldás és ugrás a következőre",
      "NAVIGATE_DROPDOWN": "Ugrás a legördülő elemekhez",
      "RESOLVE_CONVERSATION": "Beszélgetés megoldása",
      "GO_TO_CONVERSATION_DASHBOARD": "Ugrás a beszélgetések kezdőoldalára",
      "ADD_ATTACHMENT": "Csatolmány hozzáadása",
      "GO_TO_CONTACTS_DASHBOARD": "Ugrás a kapcsolatok kezdőoldalára",
      "TOGGLE_SIDEBAR": "Oldalsáv bekapcsolása",
      "GO_TO_REPORTS_SIDEBAR": "Ugrás a jelentések oldalsávra",
      "MOVE_TO_NEXT_TAB": "Ugrás a beszélgetéslista következő lapjára",
      "GO_TO_SETTINGS": "Beállítások megnyitása",
      "SWITCH_TO_PRIVATE_NOTE": "Válts privát jegyzetre",
      "SWITCH_TO_REPLY": "Válts a válasz fülre",
      "TOGGLE_SNOOZE_DROPDOWN": "Alvómód bekapcsolása a legördülő menüben",
      "AI_ASSIST_MENU": "AI segítség",
      "AI_ASSIST_GRAMMAR": "Nyelvtani javítás",
      "AI_ASSIST_UNIFY_LANG": "Üzenet nyelvének egységesítése"
    }
  }
}
